let activeDropdown = null;
const overlay = document.querySelector('.overlay_background_2');

// Helper to add mouseleave only once
function addMouseLeaveListenerOnce(dropdown) {
  if (!dropdown.dataset.leaveAttached) {
    dropdown.addEventListener('mouseleave', () => {
      dropdown.classList.remove('mega-menu-visible');
      activeDropdown = null;
      if (overlay) overlay.classList.remove('overlay_background_2--visible');
    });
    dropdown.dataset.leaveAttached = 'true';
  }
}

// Hover event for desktop
document.querySelectorAll('.menu-lv-1:has(.has-mega-menu)').forEach(item => {
  item.addEventListener('mouseenter', () => {
    const childWithTitle = item.querySelector('.has-mega-menu');
    if (!childWithTitle) return;

    const menuTitle = childWithTitle.getAttribute('data-menu-title');
    if (!menuTitle) return;

    const targetDropdown = document.querySelector(`.site-nav-dropdown[data-link-title="${menuTitle}"]`);
    if (!targetDropdown) return;

    // Hide all other dropdowns
    document.querySelectorAll('.site-nav-dropdown.mega-menu-visible').forEach(el => {
      if (el !== targetDropdown) el.classList.remove('mega-menu-visible');
    });

    // Show the current one
    targetDropdown.classList.add('mega-menu-visible');
    activeDropdown = targetDropdown;

    // Show overlay
    if (overlay) overlay.classList.add('overlay_background_2--visible');

    // Add mouseleave handler once
    addMouseLeaveListenerOnce(targetDropdown);
  });
});

// Hide on hover outside (desktop)
document.body.addEventListener('mouseover', (e) => {
  const isInsideMenu = e.target.closest('.menu-lv-1');
  const isInsideDropdown = e.target.closest('.site-nav-dropdown');

  if (!isInsideMenu && !isInsideDropdown && activeDropdown) {
    activeDropdown.classList.remove('mega-menu-visible');
    activeDropdown = null;
    if (overlay) overlay.classList.remove('overlay_background_2--visible');
  }
});

// Attach click only if dropdown match exists
document.querySelectorAll('.menu-lv-1[data-mobile-mega]').forEach(item => {
  const menuTitle = item.getAttribute('data-mobile-mega');
  if (!menuTitle) return;

  const targetDropdown = document.querySelector(`.site-nav-dropdown[data-link-title="${menuTitle}"]`);
  if (!targetDropdown) return;

  item.addEventListener('click', (e) => {
    const link = item.querySelector('a');
    if (link && (e.target === link || link.contains(e.target))) {
      e.preventDefault();
    }

    e.stopPropagation();

    // Hide all other dropdowns
    document.querySelectorAll('.site-nav-dropdown.mega-menu-visible').forEach(el => {
      if (el !== targetDropdown) el.classList.remove('mega-menu-visible');
    });

    const isVisible = targetDropdown.classList.contains('mega-menu-visible');
    if (!isVisible) {
      targetDropdown.classList.add('mega-menu-visible');
      activeDropdown = targetDropdown;
      if (overlay) overlay.classList.add('overlay_background_2--visible');

      // Add click handler to header for closing
      const headerClose = targetDropdown.querySelector('.mega-menu__header');
      if (headerClose) {
        headerClose.addEventListener('click', () => {
          targetDropdown.classList.remove('mega-menu-visible');
          activeDropdown = null;
          if (overlay) overlay.classList.remove('overlay_background_2--visible');
        }, { once: true });
      }

      // Add mouseleave handler once
      addMouseLeaveListenerOnce(targetDropdown);
    } else {
      targetDropdown.classList.remove('mega-menu-visible');
      activeDropdown = null;
      if (overlay) overlay.classList.remove('overlay_background_2--visible');
    }
  });
});

// Click/touch outside to close (mobile support)
document.addEventListener('click', (e) => {
  const isInsideDropdown = e.target.closest('.site-nav-dropdown');
  const isInsideMenu = e.target.closest('.menu-lv-1[data-mobile-mega]');

  if (!isInsideDropdown && !isInsideMenu && activeDropdown) {
    activeDropdown.classList.remove('mega-menu-visible');
    activeDropdown = null;
    if (overlay) overlay.classList.remove('overlay_background_2--visible');
  }
});
